<template>
    <be-card title="Kunde">
        <address>
            <strong>{{ assessment.organisationName }}</strong><br>
            <template v-if="assessment.organisationStreet">{{ assessment.organisationStreet }}<br></template>
            {{ assessment.organisationPostcode }} {{ assessment.organisationLocation }}<br>
            {{ assessment.organisationCountryLabel }}<br>
            <a :href="assessment.organisationWebsite" target="_blank">{{ assessment.organisationWebsite }}</a>
        </address>
        <address>
            <strong>{{ assessment.readableContactGender }} {{ assessment.contactFirstname }} {{ assessment.contactLastname }}</strong><br>
            <template v-if="assessment.contactRole">{{ assessment.contactRole }}<br></template>
            <i class="icon mdi mdi-account-box-mail mr-1"></i><a :href="`mailto:${assessment.contactEmail}`">{{ assessment.contactEmail }}</a><br>
            <i class="icon mdi mdi-account-box-phone mr-1"></i>{{ assessment.contactPhone }}
        </address>
    </be-card>
</template>

<script>
    import Assessment from '../../../../models/Assessment';

    export default {
        props: {
            assessment: Assessment,
        },
    };
</script>
